import React from 'react';
import { UI_TEXT } from '../../config/ui-text';
import { formatDuration } from '../../lib/utils';
import type { SessionTimeStats } from './sessionTimeStats';

const LABELS = UI_TEXT.HUMAN_SURVEY.RESPONSES.LABELS;
const SEPARATOR = ' · ';

const TimePart: React.FC<{ seconds: number; suffix: string }> = ({ seconds, suffix }) => (
  <>
    <span>{formatDuration(seconds)}</span> <span>{suffix}</span>
  </>
);

/** Median active time first, wall clock secondary; sessions with no active timing show wall clock alone. */
const SessionTimeSummary: React.FC<{ stats: SessionTimeStats; empty: string }> = ({
  stats,
  empty,
}) => {
  const { medianActiveSeconds: active, medianTotalSeconds: total } = stats;
  if (active == null) {
    return total == null ? (
      <>{empty}</>
    ) : (
      <TimePart seconds={total} suffix={LABELS.TOTAL_TIME_SUFFIX} />
    );
  }
  return (
    <>
      <TimePart seconds={active} suffix={LABELS.ACTIVE_TIME_SUFFIX} />
      {total != null && (
        <span className="font-normal text-gray-400">
          {SEPARATOR}
          <TimePart seconds={total} suffix={LABELS.TOTAL_TIME_SUFFIX} />
        </span>
      )}
    </>
  );
};

export default SessionTimeSummary;
